import React from 'react';
import './LoadingAnimation.css';
import { useLanguage } from '../LanguageContext';

const LoadingAnimation = ({ isLoading }) => {
  const { t } = useLanguage();
  
  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-braces">
          <div className="brace left-brace">{'{'}</div>
          <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
          <div className="brace right-brace">{'}'}</div>
        </div>
        <div className="loading-text">{t.loadingText}</div>
      </div>
    </div>
  );
};

export default LoadingAnimation;
